/**
 * Modelo de datos para Ajustes Detalles (Payment Details)
 * Contiene interfaces, tipos y configuración para el feature de detalles de pago.
 * Fecha: 01/10/2026
 */

/**
 * Interfaz que representa una factura con detalles de pago (Payment Detail).
 * Mapea la respuesta del endpoint GET /reports/get_invoices_pd.
 * Campos monetarios tipados como number (el backend retorna JSON numéricos).
 * Fecha: 01/10/2026
 */
export interface InvoicePD {
  invoice_id: number;
  payment_detail_ids: number[];     // [05/10/2026] Cambio: era payment_detail_id: number
  uuid: string;
  folio_reporte: string;            // [05/10/2026] Nuevo campo del backend
  folio_factura: string;
  serie_factura: string;
  emisor: string;                   // [05/10/2026] Nuevo campo del backend
  receptor: string;                 // [05/10/2026] Nuevo campo del backend
  fecha_emision: string;
  fecha_vencimiento: string;
  fecha_operacion: string;          // [05/10/2026] Nuevo campo del backend
  fecha_carga: string;              // [05/10/2026] Nuevo campo del backend
  moneda: string;
  total_factura: number;
  estatus_factura: string;          // [05/10/2026] Nuevo campo del backend
  tipo_registro_pago: TipoRegistroPago;
  payment_status: PaymentDetailStatus;
  saldo_pendiente: number;
  moratorios: number;
  dias_vencidos: number;
  total_a_pagar: number;
}

/**
 * Tipo literal que representa los tipos de registro de pago permitidos.
 * Valores alineados con el catálogo TIPOS_REGISTRO_PAGO del backend.
 * Fecha: 01/10/2026
 */
export type TipoRegistroPago =
  | 'PAGO ANTICIPADO'
  | 'COBRANZA FACTORAJE'
  | 'PAGO ANTICIPADO FONDEO'
  | 'COBRANZA FONDEO'
  | 'PAGO RESERVA'
  | 'PAGO MORATORIOS';

/**
 * Tipo literal para el estatus de un payment detail.
 * Valores: PAGADO, PARCIAL, PENDIENTE (alineados con el backend).
 * Fecha: 01/10/2026
 */
export type PaymentDetailStatus = 'PAGADO' | 'PARCIAL' | 'PENDIENTE';

/**
 * Configuración por tipo de pago: asocia cada pantalla con su flag
 * de parámetros generales (READ_PAYMENT_DETAILS_*) y su tipo de registro
 * de pago según el catálogo del backend.
 * Fecha: 01/10/2026
 */
export const PAYMENT_DETAIL_CONFIG: Record<string, { flag: string; tipoRegistroPago: TipoRegistroPago }> = {
  PAGO_PROVEEDOR: {
    flag: 'READ_PAYMENT_DETAILS_PAGO_PROVEEDOR',
    tipoRegistroPago: 'PAGO ANTICIPADO'
  },
  COBRANZA_CADENA: {
    flag: 'READ_PAYMENT_DETAILS_COBRANZA_FACTORAJE',
    tipoRegistroPago: 'COBRANZA FACTORAJE'
  },
  PAGO_FONDEO: {
    flag: 'READ_PAYMENT_DETAILS_PAGO_FONDEO',
    tipoRegistroPago: 'PAGO ANTICIPADO FONDEO'
  },
  COBRANZA_FONDEO: {
    flag: 'READ_PAYMENT_DETAILS_COBRANZA_FONDEO',
    tipoRegistroPago: 'COBRANZA FONDEO'
  },
  PAGO_RESERVA: {
    flag: 'READ_PAYMENT_DETAILS_PAGO_RESERVA',
    tipoRegistroPago: 'PAGO RESERVA'
  }
};
